import axios from "./_axios";
import { API } from "./apiEndPoints";
import { updateAccountCounts } from "@/utils/accountCountUtils";

export const getListofResponsibility = (account_id, page_no, size) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/`,
    params: { page: page_no, size: size },
  });
  return result;
};
export const getListofResponsibilityForBadges = ({
  accountId,
  limit,
  offset,
  name,
  status,
}) => {
  const params = {
    limit: limit,
    offset: offset,
    name: name,
    status: status,
    archived: false,
  };
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${accountId}/responsibility/`,
    params: params,
  });
  return result;
};
export const getListofResponsibilityV2 = (
  account_id,
  limit,
  offset,
  search,
  filters = {},
  ordering = null,
  include_badge_holders = false
) => {
  const params = {
    limit: limit,
    offset: offset,
    name: search,
    include_badge_holders: include_badge_holders,
  };

  // Add status filters (multiple values allowed)
  if (filters.status && filters.status.length > 0) {
    params.status = filters.status;
  }

  // Add coverage filters (single value)
  if (filters.no_masters) {
    params.no_masters = true;
  }
  if (filters.no_coaches) {
    params.no_coaches = true;
  }
  if (filters.no_professionals) {
    params.no_professionals = true;
  }

  // Add archived filter
  if (filters.archived !== undefined) {
    params.archived = filters.archived;
  }

  // Add role filter
  if (filters.role) {
    params.role = filters.role;
  }

  // Add attachments filter
  if (filters.attachments === "no") {
    params.attachments = "no";
  }

  // Add roles filter (for "No Roles" - responsibilities not attached to any roles)
  if (filters.roles === "no") {
    params.roles = "no";
  }

  // Add timeline filters
  if (filters.recently_activated) {
    params.recently_activated = true;
  }
  if (filters.recently_retired) {
    params.recently_retired = true;
  }
  if (filters.recently_deactivated) {
    params.recently_deactivated = true;
  }
  if (filters.recently_created) {
    params.recently_created = true;
  }

  // Add ordering
  if (ordering) {
    params.ordering = ordering;
  }

  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: params,
    paramsSerializer: (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  });
  return result;
};
export const getResponsibilityAttachments = (account_id, responsibility_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: { responsibility: responsibility_id, limit: 50 },
  });
  return result;
};

export const createResponsibility = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    data: data,
  });
  return result;
};

export const deleteResponsibility = (account_id, res_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/`,
  });
  return result;
};
export const updateActivateResponsibility = async (
  account_id,
  responsibility_id,
  data
) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/responsibility/${responsibility_id}/activate/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const responsibilityStateUpdate = (account_id, res_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/`,
    data: data,
  });
  return result;
};
export const updateResponsibilityPurpose = (account_id, res_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/`,
    data: data,
  });
  return result;
};

export const updateRetireResponsibility = async (account_id, res_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/responsibility/${res_id}/retire/`,
    data: data,
  });

  // Update account counts after retiring responsibility
  await updateAccountCounts(account_id);

  return result;
};
export const updateReActivateResponsibility = async (
  account_id,
  res_id,
  data
) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/responsibility/${res_id}/re-activate/`,
    data: data,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const updateArchiveResponsibility = (account_id, objType, orgId) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/archive/`,
  });
  return result;
};
export const updateUnArchiveResponsibility = (account_id, objType, orgId) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/${objType}/${orgId}/unarchive/`,
  });
  return result;
};

export const deleteRoleFromResponsibility = (account_id, res_id, role_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/role-to-responsibility/${role_id}/`,
  });
  return result;
};

export const getListofResponsibilityBadge = (
  account_id,
  res_id,
  type,
  params = {}
) => {
  let url = `${API.RESPONSIBILITY_V2}${account_id}/${type}/${res_id}/badge/`;

  if (params._query) {
    url += `?${params._query}`;
    params = {};
  }

  let result = axios()({
    method: "get",
    url: url,
    params: params,
  });
  return result;
};

export const createResponsibilityBadge = (account_id, res_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/badge/`,
    data: data,
  });
  return result;
};

export const deleteResponsibilityBadge = (account_id, badge_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/badge/${badge_id}/remove/`,
    data: data,
  });
  return result;
};

export const getResponsibilityId = (account_id, res_id, type) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/${type}/${res_id}/`,
  });
  return result;
};
export const getResponsibilityIdV2 = (account_id, res_id, type) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/${type}/${res_id}/`,
  });
  return result;
};

export const getListofEmployeeOfResId = async (
  account_id,
  page_no,
  size,
  resId = null
) => {
  const params = {
    page: page_no,
    size,
  };
  if (resId !== null && resId !== undefined) {
    params.exclude_employees_with_badge_for = resId;
  }
  const result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/employee/`,
    params,
  });

  return result;
};

export const getResponsibilityChatter = (account_id, res_id, page = 1) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/chatter/`,
    params: { page: page },
  });
  return result;
};
export const getResponsibilityChatterV2 = (
  account_id,
  res_id,
  page = 1,
  type = "responsibility"
) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/chatter/?table=${type}&record_id=${res_id}`,
    params: { page: page },
  });
  return result;
};

export const getCheckpointsList = (account_id, res_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/checkpoint/`,
  });
  return result;
};

export const addCheckpoint = (account_id, res_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/checkpoint/`,
    data,
  });
  return result;
};

export const getResponsibilityChecklistV2 = (
  account_id,
  res_id,
  params = {}
) => {
  // Filter out undefined/null values and build clean params object
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([value]) => value !== undefined && value !== null && value !== ""
    )
  );

  return axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/`,
    params: cleanParams,
  });
};

export const createResponsibilityCheckpoint = (account_id, res_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${res_id}/checkpoint/create/`,
    data: data,
  });
  return result;
};

export const createResponsibilityCheckpointV2 = (account_id, res_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/`,
    data: data,
  });
  return result;
};

export const uploadMicrolearningCheckPoint = (
  account_id,
  checkpoint_id,
  formData,
  signal
) => {
  return axios().request({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/checkpoint/${checkpoint_id}/video/`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    signal,
  });
};

export const deleteMicrolearningCheckPoint = (
  account_id,
  checkpoint_id,
  video_id
) => {
  return axios().request({
    method: "delete",
    url: `${API.RESPONSIBILITY}${account_id}/checkpoint/${checkpoint_id}/video/${video_id}`,
  });
};

export const deleteMicrolearningCheckPointV2 = (
  account_id,
  checkpoint_id,
  video_id
) => {
  return axios().request({
    method: "delete",
    url: `${API.RESPONSIBILITY_V2}${account_id}/checkpoint/${checkpoint_id}/video/${video_id}/`,
  });
};

export const deleteResponsibilityCheckpoint = (
  account_id,
  res_id,
  checkpoint_id
) => {
  let result = axios()({
    method: "delete",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/${checkpoint_id}/`,
  });
  return result;
};
export const checkpointStateUpdate = (
  account_id,
  res_id,
  checkpoint_id,
  type
) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/${checkpoint_id}/${type}/`,
  });
  return result;
};
export const changeCheckpointV2 = (account_id, res_id, checkpoint_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/${checkpoint_id}/`,
    data: data,
  });
  return result;
};
export const changeCheckpoint = (account_id, res_id, checkpoint_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/checkpoint/${checkpoint_id}/change/`,
    data: data,
  });
  return result;
};

export const saveInstructionAsDraft = (
  account_id,
  res_id,
  checkpoint_id,
  data
) => {
  let result = axios()({
    method: "post",
    url: `${API.PROFICIENCY_V1}${account_id}/responsibility/${res_id}/checkpoint/${checkpoint_id}/save-instruction-as-draft/`,
    data: data,
  });
  return result;
};

export const onUpdateCheckpointOrder = (account_id, res_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${res_id}/reorder-checkpoint`,
    data: data,
  });
  return result;
};

export const getListActiveCheckpointsEval = async (
  account_id,
  responsibility_id,
  employee_id
) => {
  let result = await axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${responsibility_id}/employee/${employee_id}/`,
  });
  return result;
};
export const getListActiveCheckpointsEvalV2 = async (
  account_id,
  responsibility,
  employee,
  limit,
  offset
) => {
  const params = {
    responsibility: responsibility,
    employee: employee,
    limit: limit,
    offset: offset,
  };
  let result = await axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/evaluation/`,
    params: params,
  });
  return result;
};
export const getAssignmentEval = async (
  account_id,
  assignment_id,
  object_type
) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/assignment/${object_type}/${assignment_id}/evaluate/`,
  });
  return result;
};

export const getCheckpointChatterList = (
  account_id,
  checkpoint_id,
  page = 1
) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/checkpoint/${checkpoint_id}/chatter/`,
    params: { page: page },
  });
  return result;
};

export const getResponsibilityAssignments = (account_id, responsibility_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibility/${responsibility_id}/assignments/`,
  });
  return result;
};
export const getResponsibilityAssignmentsV2 = (
  account_id,
  responsibility_id
) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/${responsibility_id}/assignments/`,
  });
  return result;
};

export const createProficiencyBadge = (account_id, payload) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/create-proficiency-badge/`,
    data: payload,
  });
  return result;
};

export const deleteBadge = (account_id, badge_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.RESPONSIBILITY_V2}${account_id}/badge/${badge_id}/`,
  });
  return result;
};

export const moveCheckpointOnResponsibility = (
  account_id,
  checkpoint_id,
  data
) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY_V2}${account_id}/checkpoint/${checkpoint_id}/move/`,
    data: data,
  });
  return result;
};

export const reOrderSequenceData = (account_id, role_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/role/${role_id}/sequence-reorder/`,
    data: { reordered_ids: data },
  });
  return result;
};

export const createBulkCheckpoints = (account_id, responsibility_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.PROFICIENCY_V1}${account_id}/responsibility/${responsibility_id}/checkpoint/bulk/`,
    data: data,
  });
  return result;
};

export const createBulkResponsiblities = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.PROFICIENCY_V1}${account_id}/responsibility/bulk/`,
    data: data,
  });
  return result;
};

export const getResponsibilityAssignment = (
  account_id,
  role_assignment_id,
  status = null,
  checkpoint_status = null
) => {
  let params = { role_assignment: role_assignment_id };
  if (status) {
    params.status = status;
  }
  if (checkpoint_status) {
    params.checkpoint_status = checkpoint_status;
  }

  let result = axios()({
    method: "get",
    url: `${API.PROFICIENCY_V2}${account_id}/responsibility-assignment/`,
    params: params,
  });
  return result;
};

export const createResponsibilityDefaultBadge = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY}${account_id}/badge/`,
    data: data,
  });
  return result;
};
export const fetchAttachableResponsibilities = (
  account_id,
  role_id,
  limit,
  offset,
  name
) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: {
      limit,
      offset,
      name,
      attachable_to_role: role_id,
    },
  });
  return result;
};
export const fetchAttachableRoles = (
  account_id,
  responsibility_id,
  limit,
  offset,
  name
) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: {
      limit,
      offset,
      name,
      attachable_to_responsibility: responsibility_id,
    },
  });
  return result;
};
export const fetchAttachableRolesForPosition = (
  account_id,
  position_id,
  limit,
  offset,
  name
) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/role/`,
    params: {
      limit,
      offset,
      name,
      attachable_to: position_id,
    },
  });
  return result;
};

export const updateResponsibilityDefaults = (
  account_id,
  responsibility_id,
  data
) => {
  let result = axios()({
    method: "patch",
    url: `${API.PROFICIENCY_V2}${account_id}/responsibility/${responsibility_id}/`,
    data: data,
  });
  return result;
};
